import api from './api';

/** Current clock state for the logged-in user (idle | running | on_break). */
export const getTimeClock = async () => {
    const res = await api.get('/TimeClock');
    return res.data;
};

export const startTimeClock = async () => {
    const res = await api.post('/TimeClock/start');
    return res.data;
};

export const startBreak = async () => {
    const res = await api.post('/TimeClock/break');
    return res.data;
};

export const resumeWork = async () => {
    const res = await api.post('/TimeClock/resume');
    return res.data;
};

/** Ends the day and books it; the response reports the applied break. */
export const stopTimeClock = async () => {
    const res = await api.post('/TimeClock/stop');
    return res.data;
};

/** Drops a running session without booking (forgotten stop, mis-click). */
export const discardTimeClock = async () => {
    const res = await api.delete('/TimeClock');
    return res.data;
};
